class Preloader {
  constructor () {
    this.coverList = [
      '/img/covers/cover-answer-choice.png',
      '/img/covers/cover-answer-judge.png',
      '/img/covers/cover-common.png',
      '/img/covers/cover-homework.png',
      '/img/covers/cover-red-packet.png'
    ]
  }

  init () {
    this._asyncPreload(this.coverList)
  }

  _preloadImage (url) {
    let img = new Image()
    img.src = url
  }

  // 同步 preload
  _syncPreload (list = []) {
    list.forEach(value => {
      this._preloadImage(value)
    })
  }

  // 异步 preload
  _asyncPreload (list = [], step = 200) {
    list.forEach((value, index) => {
      setTimeout(() => {
        this._preloadImage(value)
      }, index * step)
    })
  }
}

export default new Preloader()
